import { defineMessages } from 'react-intl';

export const messagesProductTile = defineMessages({
    currentPriceText: {
        defaultMessage: 'Aktueller Preis',
    },
    originalPriceText: {
        defaultMessage: 'Ursprünglicher Preis',
    },
    locationText: {
        defaultMessage: 'Standort',
    },
    ratingText: {
        defaultMessage: '{starRating} von 5 Sternen basierend auf {amountOfRatings} Bewertungen',
    },
    closeLocationText: {
        defaultMessage: 'Entfernung',
    },
    amountOfParticipantsText: {
        defaultMessage: 'Anzahl der Teilnehmer',
    },
    buttonDetailText: {
        defaultMessage: 'Leistungsbeschreibung öffnen',
    },
});
